<div class="tax-container">
    <header>
        <nav-bar></nav-bar>
        <div class="header-wrapper">
            <div class="form-process-wrapper" aria-hidden="true">
                <div class="content no-padding">
                    <div class="form-process">
                        <div class="form-title">
                            <p>Tax Certification Form</p>
                        </div>
                        <div class="form-process-steps">
                            <div class="form-process-step filled">
                                <p>Form</p>
                                <div class="form-process-step-indicator">&nbsp;</div>
                            </div>
                            <div class="form-process-step filled">
                                <p>Review</p>
                                <div class="form-process-step-indicator">&nbsp;</div>
                            </div>
                            <div class="form-process-step">
                                <p>Complete</p>
                                <div class="form-process-step-indicator">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
    <main id="main">
        <div class="content-wrapper">
            <div class="content">
                <article class="main">
                    <div class="form-section first">
                        <h1>Review and Declarations</h1>
                        <div class="insitu-help-box">
                            <div class="ui-message-icon"></div>
                            <div class="insitu-help-message">
                                <p class="medium"><strong>You're not finished yet!</strong></p>
                            </div>
                        </div>
                        <br />
                        <br />
                        <p>Please review your details below. If your details are correct, complete the "Declaration by Non-Israeli Residents" and the "Certification" sections below and click "Submit" to complete your Application. If any corrections or changes need to be made, please use the "Back" button at the bottom of this page.</p>
                        <br />
                        <h2>Declaration of Status For Israeli Income Tax Purposes</h2>
                        <div class="form_section_grouper review">
                            <dl>
                                <dt class="grouping">Broker Privacy Authorization</dt>
                                <dt>Broker Name</dt>
                                <dd>{{broker.brokerName}}</dd>
                                <dt>Authorized to Receive Data</dt>
                                <dd>{{broker.privacyAuthorization}}</dd>
                                <dt>Broker Account Number or Name</dt>
                                <dd>{{broker.accountNumber}}</dd>

                                <dt class="grouping">Number of CyberArk Shares</dt>
                                <dt>Number of CyberArk Shares</dt>
                                <dd>{{shareOwnership.numberOfShares|number}}</dd>
                                <dt>Gross Cash Consideration</dt>
                                <dd>{{shareOwnership.certificationValue | currency}}</dd>
                                <dt>My gross cash consideration does not exceed US $300,000.00 does not exceed $300,000.00</dt>
                                <dd>{{shareOwnership.shareWorthLess300k}}</dd>
                                <!--<dt>I hold the Shares of the Company</dt>
                                <dd>{{sharesOfCompany}}</dd>-->
                                <dt *ngIf="shareOwnership.holdingType=='2'">Name of Broker/Financial Advisor/Custodian</dt>
                                <dd *ngIf="shareOwnership.holdingType=='2'">{{shareOwnership.shareBrokerName}}</dd>
                                <dt *ngIf="identity.typeId=='2'"> Do you have a valid passport (not expired)</dt>
                                <dd *ngIf="identity.typeId=='2'">{{identity.havePassport}}</dd>
                                <dt>Less than 5% in of CyberArk’s outstanding shares</dt>
                                <dd>Yes</dd>

                                <!-- Holding type section is hidden -->
                                <div style="display: none;">
                                    <dt>I hold the Shares of the Company</dt>
                                    <dd>{{sharesOfCompany}}</dd>
                                </div>

                                <dt class="grouping">Supporting Documentation</dt>
                                <dt>Attachments</dt>
                                <dd *ngIf="fileAttachments != null && fileAttachments.length > 0">
                                    <ul class="attachments">
                                        <li *ngFor="let file of fileAttachments">
                                            <a href="javascript:void(0)" title="Click to download file" (click)="downloadFile(file.fileId,file.fileName);">{{file.fileName}}</a>&nbsp;<span>({{file.type}} - {{file.size / 1000000 | number:'1.2-2'}} MB )</span>
                                        </li>
                                    </ul>
                                </dd>
                                <dd class="full-width" *ngIf="fileAttachments != null && fileAttachments.length == 0">
                                    No document attached.
                                </dd>

                                <dt class="grouping">Your Details</dt>
                                <dt>Name</dt>
                                <dd>{{identity.name}}</dd>
                                <dt>Former Shareholder Type</dt>
                                <dd *ngIf="identity.typeId!=8;else otherType">{{identity.type}}</dd>
                                <ng-template #otherType>
                                    <dd>{{identity.type}}: {{identity.otherType}}</dd>
                                </ng-template>
                                <dt>Residency Country</dt>
                                <dd>{{selectedcountryOfResidence}}</dd>

                                <ng-container *ngIf="identity.typeId!='2'">
                                    <dt>Corporation Country</dt>
                                    <dd>{{selectedcountryOfIncorporation}}</dd>
                                    <dt>Corporation Number</dt>
                                    <dd>{{identity.corporationNumber}}</dd>
                                </ng-container>

                                <ng-container *ngIf="identity.typeId=='2'">
                                    <dt>Date of Birth</dt>
                                    <dd>{{identity.dateofBirth | date : 'MM-dd-yyyy'}}</dd>
                                    <dt>Country of Citizenship</dt>
                                    <dd>{{selectedCountriesOfCitizenship}}</dd>
                                    <dt>Taxpayer Identification or Social Security Number</dt>
                                    <dd>{{identity.taxIdentificationNumber}}</dd>
                                    <dt>I am or had been Israeli citizen (regardless of any other citizenship)</dt>
                                    <dd>{{israeliCitizenYesNo}}</dd>
                                    <dt *ngIf="israeliCitizenYesNo === 'Yes'">Israeli Citizen ID Number</dt>
                                    <dd *ngIf="israeliCitizenYesNo === 'Yes'">{{identity.israeliCitizenIdNumber}}</dd>

                                </ng-container>

                                <dt class="grouping">Contact Details</dt>
                                <dt>Name</dt>
                                <dd>{{contact.name}}</dd>
                                <dt>Capacity</dt>
                                <dd>{{contact.capacity}}</dd>
                                <dt>Telephone Number</dt>
                                <dd>{{contact.telephone}}</dd>
                                <dt>Email Address</dt>
                                <dd>{{contact.email}}</dd>
                                <dt>Permanent Address</dt>
                                <dd>
                                    {{contact.streetAddress1}}<br />
                                    <span *ngIf="contact.streetAddress2.length>0">  {{contact.streetAddress2}}<br /></span>

                                    {{contact.streetCity}}, {{contact.streetState}}, {{contact.streetPostcode}}<br />
                                    {{selectedPrCntfResidence}}
                                </dd>
                                <ng-container *ngIf="contact.isMalingAddressDifferent=='Yes'">
                                    <dt>Mailing Address</dt>
                                    <dd>
                                        {{contact.mailingAddress1}}<br />
                                        <span *ngIf="contact.mailingAddress2.length>0">  {{contact.mailingAddress2}}<br /></span>
                                        {{contact.mailingCity}}, {{contact.mailingState}}, {{contact.mailingPostcode}}<br />
                                        {{selectedMailingCnt}}
                                    </dd>
                                </ng-container>
                            </dl>
                        </div>
                    </div>

                    <form [formGroup]="taxReview" (submit)="submitTaxReview()">

                        <div class="form-section" id="not_israel" *ngIf="(identity.residencyCountry != null) && (identity.residencyCountry != 'ISR')">
                            <h2>Declaration by Non-Israeli Residents</h2>
                            <div class="form-input full-width">
                                <div class="form-input-group" id="shareownership_only">
                                    <h3>Share Ownership</h3>
                                    <div class="form-input full-width">
                                        <div class="form-check-group">
                                            <div class="form-check">
                                                <ejs-checkbox label="I acquired the Shares on or after the listing of the Company on Nasdaq on September 24, 2014, and throughout the entire holding period I was not an Israeli tax resident. <span class='nowrap'><cite>*</cite></span>"
                                                              formControlName="hasSahreOwner" aria-required="true">
                                                </ejs-checkbox>
                                            </div>
                                        </div>
                                        <validator id="hasSahreOwner" [controlToValiddate]="'hasSahreOwner'" [errorCollection]="errorCollection"></validator>
                                    </div>

                                    <div class="form-input full-width" *ngIf="(this.shareOwnership.shareWorthLess300k == 'Yes')">
                                        <div class="form-check-group">
                                            <div class="form-check">
                                                <ejs-checkbox label="My cash consideration does not exceed US $300,000. (The portion of the consideration payable in shares of Parent does NOT count towards such amount) <span class='nowrap'><cite>*</cite></span>"
                                                              formControlName="hasLessThan300k" aria-required="true">
                                                </ejs-checkbox>
                                            </div>
                                        </div>
                                        <validator id="hasLessThan300k" [controlToValiddate]="'hasLessThan300k'" [errorCollection]="errorCollection"></validator>
                                    </div>

                                    <div class="form-input full-width" *ngIf="(this.shareOwnership.shareWorthLess300k == 'No') && (this.shareOwnership.shareWorthMore500k == 'No')">
                                        <div class="form-check-group">
                                            <div class="form-check">
                                                <ejs-checkbox label="My cash consideration exceeds US$300,000 but does not exceed US$500,000. [(The portion of the consideration payable in shares of Parent does NOT count towards such amount) <span class='nowrap'><cite>*</cite></span>"
                                                              formControlName="hasLessThan500k" aria-required="true">
                                                </ejs-checkbox>
                                            </div>
                                        </div>
                                        <validator id="hasLessThan500k" [controlToValiddate]="'hasLessThan500k'" [errorCollection]="errorCollection"></validator>
                                    </div>

                                    <div class="form-input full-width">
                                        <div class="form-check-group">
                                            <div class="form-check">
                                                <ejs-checkbox label="I did not purchase/receive my Shares from a <span class='nowrap'>Relative <sup>1</sup> <cite>*</cite></span>"
                                                              formControlName="notRelative" aria-required="true">
                                                </ejs-checkbox>
                                            </div>
                                        </div>
                                        <validator id="notRelative" [controlToValiddate]="'notRelative'" [errorCollection]="errorCollection"></validator>
                                    </div>

                                    <div class="form-input full-width">
                                        <div class="form-check-group">
                                            <div class="form-check">
                                                <ejs-checkbox label="My Shares were not subject to Part E2 of the Ordinance (Israeli tax-free <span class='nowrap'>reorganization). <cite>*</cite></span>"
                                                              formControlName="notE2" aria-required="true">
                                                </ejs-checkbox>
                                            </div>
                                        </div>
                                        <validator id="notE2" [controlToValiddate]="'notE2'" [errorCollection]="errorCollection"></validator>
                                    </div>
                                </div>

                                <p class="footnote"><sup>1</sup> Relative – (1) spouse, brother, sister, parent, grandparent, offspring, spouse's offspring, and the spouse of any of the aforementioned; (2) offspring of a brother or sister, and brother or sister of a parent.</p>
                            </div>

                            <!-- Individuals -->
                            <div class="form-input-group" id="individual_only" *ngIf="identity.typeId =='2'">
                                <h3>Individuals</h3>
                                <div class="form-input full-width">
                                    <div class="form-check-group">
                                        <div class="form-check">
                                            <ejs-checkbox label="I am NOT and since the date of purchase/  receipt of my Shares and until the dated of the Merger have not been a “resident of Israel” for tax purposes, as defined under the Ordinance (regardless of the application of any double tax treaty), which means, among other things, <span class='nowrap'>that: <cite>*</cite></span>"
                                                          formControlName="isIndividual" aria-required="true">
                                            </ejs-checkbox>
                                            <ul class="declare">
                                                <li>The State of Israel is not my permanent place of residence;</li>
                                                <li>The State of Israel is neither my place of residence nor that of my family;</li>
                                                <li>The ordinary or permanent place of my business and financial activity is NOT in the State of Israel, and I do NOT have a permanent establishment in the State of Israel;</li>
                                                <li>I do NOT engage in an occupation in the State of Israel,</li>
                                                <li>I do NOT own business or part of a business in the State of Israel;</li>
                                                <li>I am NOT covered by the Israeli National Insurance Institution;</li>
                                                <li>I was NOT present in Israel for 30 days or more between January 1, 2025 and December 31, 2025, and the total period of my presence in Israel between January 1, 2023 and December 31, 2025 is less than 180 days in total.</li>
                                                <li>I was NOT present in Israel more than 75 days in any year since the date of the purchase of the Shares and until the date of the Merger.</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <validator id="isIndividual" [controlToValiddate]="'isIndividual'" [errorCollection]="errorCollection"></validator>
                                </div>
                            </div>

                            <!--dont show for individual, trust and partnership-->
                            <div class="form-input-group" id="financial_only" *ngIf="(identity.typeId !='2'  && identity.typeId !='4' && identity.typeId !='3' )">
                                <h3>Corporations (Except Partnerships and Trusts)</h3>
                                <div class="form-input full-width">
                                    <div class="form-check-group">
                                        <div class="form-check">
                                            <ejs-checkbox label="The corporation is NOT and since the date of purchase /  receipt of its Shares and until the date of the Merger has not been a “resident of Israel” for tax purposes, as defined under the Ordinance, which means, among other things, <span class='nowrap'>that: <cite>*</cite></span>"
                                                          formControlName="iscooperation" aria-required="true">
                                            </ejs-checkbox>
                                            <ul class="declare">
                                                <li>The corporation is NOT registered with the Registrar of Companies in Israel;</li>
                                                <li>The corporation is NOT registered with the Registrar of “Amutot” (non-profit organizations) in Israel;</li>
                                                <li>The control of the corporation is NOT situated in Israel;</li>
                                                <li>The management of the corporation is NOT located in Israel;</li>
                                                <li>The corporation does NOT have a permanent establishment in Israel; and</li>
                                                <li>
                                                    No Israeli resident holds, directly or indirectly via shares or through a trust or in any other manner or "with another" or with others that are Israeli resident, 25.0% or more of any “means of control” in the corporation as specified below:
                                                    <ul>
                                                        <li>The right to participate in profits;</li>
                                                        <li>The right to appoint a director;</li>
                                                        <li>The right to vote;</li>
                                                        <li>The right to share in the assets of the corporation at the time of its liquidation; and</li>
                                                        <li>The right to direct the manner of exercising one of the rights specified above.</li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <validator [controlToValiddate]="'iscooperation'" [errorCollection]="errorCollection"></validator>
                                </div>
                            </div>

                            <div class="form-input-group" id="partnership_only" *ngIf="(identity.typeId =='4')">
                                <h3>Partnerships</h3>
                                <div class="form-input full-width">
                                    <div class="form-check-group">
                                        <div class="form-check">
                                            <ejs-checkbox label="The partnership is NOT and since the date of purchase/  receipt of its Shares and until the dated of the Merger has not been a “resident of Israel” for tax purposes, as defined under the Ordinance, which means, among other things, <span class='nowrap'>that: <cite>*</cite></span>"
                                                          formControlName="ispartnerships" aria-required="true">
                                            </ejs-checkbox>
                                            <ul class="declare">
                                                <li>The partnership is NOT registered with the Registrar of Partnerships in Israel;</li>
                                                <li>The control of the partnership is NOT situated in Israel;</li>
                                                <li>The management of the partnership is NOT located in Israel;</li>
                                                <li>The partnership does NOT have a permanent establishment in Israel;</li>
                                                <li>NO Israeli resident holds, directly or indirectly via shares or through a trust or in any other manner or "with another" or with others that are Israeli resident, 25.0% or more of any right in the partnership or, of the right to direct the manner of exercising any of the rights in the partnership; and</li>
                                                <li>NO partner in the partnership is an Israeli resident;</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <validator id="ispartnerships" [controlToValiddate]="'ispartnerships'" [errorCollection]="errorCollection"></validator>
                                </div>
                            </div>

                            <div class="form-input-group" id="trust_only" *ngIf="(identity.typeId =='3' )">
                                <h3>Trusts</h3>
                                <div class="form-input full-width">
                                    <div class="form-check-group">
                                        <div class="form-check">
                                            <ejs-checkbox label="The trust is NOT and since the date of purchase / receipt of its Shares and until the dated of the Merger has not been a “resident of Israel” for tax purposes, as defined under the Ordinance, which means, among other things, <span class='nowrap'>that: <cite>*</cite></span>"
                                                          formControlName="istrust" aria-required="true">
                                            </ejs-checkbox>
                                            <ul class="declare">
                                                <li>The trust is NOT registered in Israel;</li>
                                                <li>NONE of the settlors of the trust are Israeli residents;</li>
                                                <li>The trust does NOT have a permanent establishment in Israel;</li>
                                                <li>NONE of the beneficiaries of the trust are Israeli residents; and</li>
                                                <li>The trustee of the trust is NOT an Israeli resident.</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <validator id="istrust" [controlToValiddate]="'istrust'" [errorCollection]="errorCollection"></validator>
                                </div>
                            </div>
                        </div>

                        <div class="form-section" *ngIf="((identity.typeId =='5'|| identity.typeId =='6'|| identity.typeId =='7' )) &&(identity.residencyCountry != null && identity.residencyCountry =='ISR')">
                            <h2>Declaration by Israeli Bank, Broker or Financial Institution</h2>
                            <div class="form-input-group">
                                <div class="form-input full-width">
                                    <div class="form-check-group">
                                        <div class="form-check">
                                            <ejs-checkbox label="I am a bank, broker or financial institution that is a “resident of Israel” within the meaning of that term in Section 1 of the Ordinance, I am holding the ordinary shares solely on behalf of beneficial holder(s) and I am subject to the provisions of the Ordinance and the regulations promulgated thereunder relating to the withholding of Israeli tax, including with respect to the cash payment (if any) made by me to such beneficial holder(s) with respect to ordinary Shares in connection with the merger.We hereby confirm that we are aware of the existence and terms of the “Interested Public” Tax Ruling (Pre-Ruling) No. 20252251. Any withholding tax at source shall be made such that the original acquisition price (cost basis) taken into account for the purposes of calculating the capital gain will be determined in accordance with Section 104H(b)(1A)(b) of the Income Tax Ordinance [New Version]."
                                                          formControlName="declaration" aria-required="true">
                                            </ejs-checkbox>
                                        </div>
                                    </div>
                                    <validator id="declaration" [controlToValiddate]="'declaration'" [errorCollection]="errorCollection"></validator>
                                </div>
                            </div>
                        </div>

                        <div class="form-section">
                            <h3>Certification</h3>
                            <div class="form-input-group">
                                <div class="form-input full-width">
                                    <div class="form-check-group">
                                        <div class="form-check">
                                            <ejs-checkbox label="By signing this form, I also declare <span class='nowrap'>that: <cite>*</cite></span>"
                                                          formControlName="certification" aria-required="true">
                                            </ejs-checkbox>
                                            <ul class="declare">
                                                <li>I understood this form and completed it correctly and pursuant to the instructions.</li>
                                                <li>I provided accurate, full and complete details in this form.</li>
                                                <li>I am aware that providing false details constitutes a criminal offense.</li>
                                                <li>I am aware that this form may be provided to the Israeli Tax Authority, in case the Israel Tax Authority so requests, for purposes of audit or otherwise.</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <validator id="certification" [controlToValiddate]="'certification'" [errorCollection]="errorCollection"></validator>
                                </div>
                            </div>
                        </div>

                        <div class="form-section" *ngIf="enableOwnerForm">
                            <h1>Beneficial Owner Declaration</h1>
                            <div [innerHTML]="ownerFormIntro"></div>

                            <h2>Declarations</h2>
                            <div class="form-input-group">
                                <div class="form-input full-width">
                                    <div class="form-check-group">
                                        <div class="form-check">
                                            <ejs-checkbox label="I hereby declare that I have complete the above &quot;Declaration of Status for Israeli Income Tax Purposes&quot; detailing my identification details and a declaration of non-Israeli <span class='nowrap'>residency. <cite>*</cite></span>"
                                                          formControlName="taxDeclarationCompleted" aria-required="true">
                                            </ejs-checkbox>
                                        </div>
                                    </div>
                                    <validator id="taxDeclarationCompleted" [controlToValiddate]="'taxDeclarationCompleted'" [errorCollection]="errorCollection"></validator>
                                </div>
                            </div>

                            <div class="form-input-group">
                                <div class="form-input full-width">
                                    <div class="form-check-group">
                                        <div class="form-check">
                                            <ejs-checkbox label="I hereby declare that, in connection with my eligibility to receive additional contingent consideration in the Merger, as reflected by each unit of &quot;Contingent Value Right&quot; or &quot;CVR&quot; arising from Shares that were registered under my name or held for my benefit as beneficial owner of the CVRs in the CVR Registry, I hereby confirm and declare that since the Closing Date and until the date hereof, there has been no change in the beneficial ownership of the CVRs (a &quot;Change of Ownership&quot;). Note: A Change of Ownership does not include changes to the CVR Registry so long as the beneficial owner of the CVR does not change (for example, in circumstances of transfer of registration from a foreign broker or trustee to the CVR <span class='nowrap'>owner). <cite>*</cite></span>"
                                                          formControlName="noChangeofOwnership" aria-required="true">
                                            </ejs-checkbox>
                                        </div>
                                    </div>
                                    <validator id="noChangeofOwnership" [controlToValiddate]="'noChangeofOwnership'" [errorCollection]="errorCollection"></validator>
                                </div>
                            </div>
                        </div>

                        <div class="form-section" *ngIf="enableOwnerForm">
                            <h2>Certification</h2>
                            <div class="form-input-group">
                                <div class="form-input full-width">
                                    <div class="form-check-group">
                                        <div class="form-check">
                                            <ejs-checkbox label="I also declare that: <cite>*</cite>"
                                                          formControlName="beneficialOwnerCertification">
                                            </ejs-checkbox>
                                            <ul class="declare">
                                                <li>I understood this form and completed it correctly.</li>
                                                <li>I provided accurate, full and complete details in this form.</li>
                                                <li>I am aware that providing false details constitutes criminal offense.</li>
                                                <li>I am aware that this form may be provided to the Israel Tax Authority, in case the Israel Tax Authority so requests, for purposes of audit or otherwise.</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <validator id="beneficialOwnerCertification" [controlToValiddate]="'beneficialOwnerCertification'" [errorCollection]="errorCollection"></validator>
                                </div>
                            </div>
                        </div>

                        <h3>Further Declarations and Acknowledgments</h3>
                        <div class="form-input-group">
                            <div class="form-input full-width">
                                <div class="form-check-group">
                                    <div class="form-check">
                                        <ejs-checkbox label="I/we declare that the above is true and <span class='nowrap'>correct. <cite>*</cite></span>"
                                                      formControlName="hasAgree" aria-required="true">
                                        </ejs-checkbox>
                                    </div>
                                </div>
                                <validator [controlToValiddate]="'hasAgree'" [errorCollection]="errorCollection"></validator>
                            </div>
                        </div>

                        <div class="form-input-group">
                            <div class="form-input full-width">
                                <div class="form-check-group">
                                    <div class="form-check">
                                        <ejs-checkbox label="By checking this box, you are signing this agreement. Your metadata will be recorded as part of your <span class='nowrap'>signature. <cite>*</cite></span>"
                                                      formControlName="agreeMetadata" aria-required="true">
                                        </ejs-checkbox>
                                    </div>
                                </div>
                                <validator [controlToValiddate]="'agreeMetadata'" [errorCollection]="errorCollection"></validator>
                            </div>
                        </div>

                        <div class="button-area">
                            <div class="buttons-left">
                                <div>
                                    <button ejs-button class="e-primary e-bigger" iconCss="e-icons e-check-icon" iconPosition="Right">Submit</button>
                                </div>
                                <div>
                                    <button ejs-button class="e-bigger" iconCss="e-icons e-chevron-left-icon" (click)="onBackClick()" iconPosition="Left">Back</button>
                                </div>
                                <div>
                                    <button ejs-button class="e-bigger" iconCss="e-icons e-close-icon" iconPosition="Left" (click)="showCancelConfirmationDialog($event)">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </article>
            </div>
        </div>
    </main>
    <footer-bar></footer-bar>
</div>

<ejs-dialog #cancelConfirmationDialog id="cancelConfirmationDialog"
            [showCloseIcon]="false"
            [visible]="visible"
            width="400px"
            isModal="true"
            [target]="targetElement">
    <ng-template #header>
        Cancel Confirmation
    </ng-template>
    <ng-template #content>
        <p>All information input into this form will be discarded.</p>
        <p><strong>Are you sure you wish to cancel?</strong></p>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="ui-dialog-buttonpane ui-helper-clearfix">
            <button ejs-button class="e-primary float-right" iconCss="e-icons e-check-icon" (click)="confirmYes()" iconPosition="Right">Yes</button>
            <button ejs-button class="float-left" iconCss="e-icons e-close-icon" iconPosition="Left" (click)="hideCancelConfirmationDialog();">No</button>
        </div>
    </ng-template>
</ejs-dialog>
